import { FormControl, InputLabel, Select as MuiSelect } from '@mui/material';
import React, { useMemo } from 'react';
import slugify from 'slugify';

export default function Select(props) {
  const {
    id,
    color,
    label,
    sx,
    sxFormControl,
    hideLabel,
    ...otherProps
  } = props;
  const slug = useMemo(() => slugify(`label-${id ?? label ?? ''}`), [id, label]);

  return (
    <FormControl color={color} fullWidth sx={sxFormControl}>
      <InputLabel
        color={color}
        id={slug}
        size="small"
        sx={{ display: hideLabel ? 'none' : 'inherit' }}
      >
        {label}
      </InputLabel>
      <MuiSelect
        color={color}
        // IconComponent={FiArrowDown}
        label={hideLabel ? null : label}
        labelId={slug}
        size="small"
        sx={{
          ...sx,
          '&.MuiInputBase-colorSecondary .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme) => theme.palette.secondary.main,
          },
        }}
        {...otherProps}
        inputProps={{
          'aria-label': label,
          'aria-labelledby': slug,
          ...(otherProps.inputProps || {}),
        }}
      />
    </FormControl>
  );
}

Select.propTypes = {
  ...MuiSelect.propTypes,
};
